export const ACCESS_TOKEN = 'Access-Token'
export const SIDEBAR_TYPE = 'SIDEBAR_TYPE'
export const DEFAULT_THEME = 'DEFAULT_THEME'
export const DEFAULT_LAYOUT_MODE = 'DEFAULT_LAYOUT_MODE'
export const DEFAULT_COLOR = 'DEFAULT_COLOR'
export const DEFAULT_COLOR_WEAK = 'DEFAULT_COLOR_WEAK'
export const DEFAULT_FIXED_HEADER = 'DEFAULT_FIXED_HEADER'
export const DEFAULT_FIXED_SIDEMENU= 'DEFAULT_FIXED_SIDEMENU'
export const DEFAULT_FIXED_HEADER_HIDDEN = 'DEFAULT_FIXED_HEADER_HIDDEN'
export const DEFAULT_CONTENT_WIDTH_TYPE = 'DEFAULT_CONTENT_WIDTH_TYPE'
export const DEFAULT_MULTI_PAGE = 'DEFAULT_MULTI_PAGE'
export const USER_ID = 'Login_userId'
export const USER_LOGIN_NAME = 'Login_loginName'
export const USER_NAME = 'Login_Username'
export const USER_INFO = 'Login_Userinfo'
export const USER_DI = 'Login_UserDI'
export const USER_AUTH = 'LOGIN_USER_BUTTON_AUTH'
export const SYS_BUTTON_AUTH = 'SYS_BUTTON_AUTH'
export const ENCRYPTED_STRING = 'ENCRYPTED_STRING'
export const ENHANCE_PRE = 'enhance_'
export const UI_CACHE_DB_DICT_DATA = 'UI_CACHE_DB_DICT_DATA'
export const INDEX_MAIN_PAGE_PATH =  "/dashboard/analysis"
//路由缓存问题，关闭了tab页时再打开就不刷新 #842
export const CACHE_INCLUDED_ROUTES = 'CACHE_INCLUDED_ROUTES'

// const fb = process.env.VUE_APP_PRINT_URL;
// let printUrl = ''
// if(fb == 'TJ'){
//   //天津平台
//   printUrl="print.fangzhima.com"
// }else if(fb == 'TC'){
//   // 天创平台
//   printUrl="print.tianchuangdata.com"
// }else if(fb == 'DEV'){
//   // 开发
//   printUrl="111.161.65.253:8891"
// }else if(fb == 'PROD'){
//   // 开发
//   printUrl="111.161.65.253:8891"
// }else if(fb == 'test'){
//   // 测试
//   printUrl="111.161.65.253:8890"
// }
export const PRINT_WEB_URL= process.env.VUE_APP_PRINT_URL
export const SCANNER_WEB_URL= process.env.VUE_APP_SCANNER_URL
// export const SCANNER_WEB_URL= "file:///D:/git/web-serial/index.html"
//测试
// export const PRINT_WEB_URL="111.161.65.253:8890"

// export const PRINT_WEB_URL="localhost:3000"
export const CONTENT_WIDTH_TYPE = {
  Fluid: 'Fluid',
  Fixed: 'Fixed'
}